<template>
  <div class="div-login">
    <div class="login">
      <!-- <el-card> -->
      <el-form class="login-form" :model="model" :rules="rules" ref="form" @submit.native.prevent="login">
        <h2 style="text-align: center;font-size: 18px;margin:15px 0px">登录</h2>
        <i @click="closeLoginCard" class="el-icon-close closeStyle"></i>
        <el-form-item prop="username">
          <el-input v-model="model.username" placeholder="请输入用户名" prefix-icon="el-icon-user-solid"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="model.password" placeholder="请输入密码" type="password" prefix-icon="el-icon-s-goods"></el-input>
        </el-form-item>
        <div class="ukStyle">
            <span style="color:#000;font-size:12px;cursor: pointer;" @click="openUkLogin" >UK登录</span>
            <el-tooltip class="item" effect="dark" content="请联系系统管理员重置密码" placement="top-start">
                <span style="color:#000;font-size:12px;cursor: pointer;">忘记密码</span>
            </el-tooltip>
        </div>
        <el-form-item>
          <el-button :loading="loading" class="login-button" type="primary" native-type="submit" block>登录</el-button>
        </el-form-item>

        <el-form-item  v-if="false">
            <el-button  v-if="false" @click="downloadBIMPlugin()" title="BIM插件下载"  class="download-btn1 el-icon-s-order" ></el-button>
            <el-button  v-if="false" @click="downloadPlugin()" title="插件下载"  class="download-btn1 el-icon-download" ></el-button>
            <!-- <el-button title="UK登录" class="download-btn1 el-icon-s-ticket" @click="openUkLogin" >UK登录</el-button> -->
            <!-- <span class="" @click="openUkLogin" >UK登录</span> -->


          <el-popover  v-if="false" @show="showQrcode" @hide="hiddenQrcode" placement="bottom" title width="120" trigger="click" content>
            <el-button title="扫码登录" class="download-btn1 el-icon-mobile" slot="reference"></el-button>
            <img @click="reloadOrCode" class="login__app" :src="orCodeUrl" id="appQrCode" width="150" height="150" />
          </el-popover>
        </el-form-item>
        <!-- <a class="forgot-password" href="https://oxfordinformatics.com/">Forgot password ?</a> -->
      </el-form>
      <!-- </el-card> -->
      <form style="display: none;" action="/api/ssoserver/login/comein" class="formsubz" method="post" name="login_form">
        <input name="action" type="hidden" value="login">
        <input id="authType" value="9;0;3" name="auth" type="hidden" />
        <input id="sign_value" name="sign_value" type="hidden" />
        <input type="hidden" name="signfield" value="cn" />
        <input type="hidden" name="personfield" value="uid" />
        <input type="hidden" name="randomNumber" value="" />
        <input type="hidden" id="loginType" name="logintype" value="2">
      </form>
    </div>
  </div>
</template>

<script>
import { certificatesignauthen, ukConfig } from "./../js/caLogin";
export default {
  name: "loginCard",
  data() {
    return {
      validCredentials: {
        username: "lightscope",
        password: "lightscope"
      },
      model: {
        username: "",
        password: ""
      },
      loading: false,
      //输入限制规则
      rules: {
        username: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur"
          }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      orCodeUrl: "",

      timess: 1,
      res: ""
    };
  },
  beforeDestroy() {
    clearInterval(this.res);
  },
  methods: {
      closeLoginCard(){
          console.log("点击关闭1")
          this.$emit("closeLoginCard")

      },
    downloadPlugin(){
          window.open('/zqdownload/download.html');
      },
    downloadBIMPlugin(){
      window.open('http://220.165.247.69:11101/Content/StaticPage/Download/BimPluginDownload/BimPluginDownload.html');
    },
    //跳转到UK登录
    openUkLogin() {
      var randomNumber = "";
      for (var i = 0; i < 6; i++) {
        randomNumber += Math.floor(Math.random() * 10).toString();
      }
      if (ukConfig()) {
        certificatesignauthen(randomNumber, "", result => {
          result = JSON.parse(result)
          if (result.success) {
            this.$emit("clickLogin", {
              user: result.uid,
              token: result.token,
              time: result.time
            });
          }else{
            this.$message.error('UK登陆失败:'+result.msg)
          }
        });
      } else {
        this.$message.info("控件未安装！");
      }
    },
    showQrcode() {
      this.validateLogin();
    },
    hiddenQrcode() {
      clearInterval(this.res);
    },
    simulateLogin() {
      return new Promise(resolve => {
        setTimeout(resolve, 800);
      });
    },
    //轮询检查是否登录
    validateLogin() {
      this.orCodeUrl = "";
      this.$nextTick(() => {
        this.orCodeUrl =
          "/api/ssoserver/scavenlogin/getscavenimg";
        this.res = setInterval(this.validateOper, 2000);
      });
    },

    //发送请求校验是否已完成登录
    validateOper() {
      this.timess++;
      if (this.timess >= 61) {
        this.orCodeUrl =
          "/api/ssoserver/image/mobileapp/scan/expiresmall.png";
        this.hiddenQrcode();
        return;
      }
      this.$axios
        .get(
          `/api/ssoserver/currency/ckplcodeAtd?appId=${process.env.APP_ID}&isLocal=false&date=` +
            Date.parse(new Date(), {
              crossDomain: true
            })
        )
        .then(res => {
          if (res) {
            var result = res.data;
            if (result.indexOf(",_,") != -1) {
              var arr = result.split(",_,");

              if ("success" == arr[0]) {
                let isAround = false;
                location.href = "http://220.165.247.94:8280/ssoserver" + arr[1];
              } else if (arr[1] == "I0000000") {
                let isAround = false;
                this.$message.error(
                  "您的二维码已经在其他地方登录请重新点击二维码登录"
                );
              }
            } else {
              result = JSON.parse(result);
              if (result.success) {
                this.$emit("clickLogin", {
                  user: result.uid,
                  token: result.token,
                  time: result.time
                });
              }else{
                this.$message.error(
                  result.msg
                );
              }
              this.hiddenQrcode();
            }
          }
        })
        .catch(error => {});
    },
    //刷新二维码
    reloadOrCode() {
      this.timess = 1;
      this.res = "";
      this.orCodeUrl = "";
      this.validateLogin();
    },
    async login() {
      let valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      //check-login
      this.$emit("appLogin", {
        user: this.model.username,
        pwd: this.model.password
      });
      // this.loading = true;
      // await this.simulateLogin();
      // this.loading = false;
      // if (
      //   this.model.username === this.validCredentials.username &&
      //   this.model.password === this.validCredentials.password
      // ) {
      //   this.$message.success("Login successfull");
      // } else {
      //   this.$message.error("Username or password is invalid");
      // }
    }
  }
};
</script>

<style>
.div-login .download-btn {
  float: right;
  padding: 0;
  font-size: 20px;
  border: 0;
  color: #bfbfc1;
}

.div-login .download-btn1 {
  margin-left: 0;
  /* float: right; */
  margin-right: 20px;
  padding: 0;
  font-size: 20px;
  border: 0;
  color: #bfbfc1;
}

.div-login .el-input__inner {
  background-color: #f1f2f7;
  border: 0 !important;
  outline: 0 !important;
}

.div-login .el-input__inner:hover {
  border: 0;
}

.div-login .el-input__prefix {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  left: 0 !important;
  background-color: #42bcfb !important;
}
.div-login .el-input__icon {
  font-size: 20px;
  width: 40px !important;
  color: #fff !important;
}
.div-login .el-input--prefix .el-input__inner {
  padding-left: 45px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.div-login {
  position: absolute;
  top: -100px;
  bottom: 0;
  left: 0;
  width: 100%;
}
.el-form-item{
    margin-bottom: 20px !important;
}
.el-form-item__content {
  .login-button {
    margin-top: 0px !important;
    background-color: #42bcfb !important;
    border: 0;
  }
}
.footer {
  height: 8%;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #017ddd;
  p {
    margin: 0;
    padding: 0;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    color: #6ea8df;
  }
  hr {
    margin: 0;
    height: 0;
    margin-top: 10px;
    border-style: solid;
    border-color: #74b7ec;
    border-width: 1px 0 0;
  }
}
.login {
  overflow: hidden;
  position: absolute;
  width: 100%;
  top: -6%;
  bottom: 6%;
  left: 0;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    position: relative;
    border-radius: 5px;
    width: 260px;
    background-color: #ffffff;
    padding: 10px 20px;
    margin: 0;
  }
}
.login__shadow {
  z-index: -1;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: rotate(45deg);
  transform-origin: left bottom;
  height: 160%;
}

.login-button {
  width: 100%;
  margin-top: 40px;
}
.forgot-password {
  margin-top: 10px;
}
</style>
<style lang="less" scoped>
@inputbg: #283442;
// @teal: rgb(0, 124, 137);
@teal: #1890ff;

.el-input input {
  background: @inputbg;
  // border: 0;
  -webkit-appearance: none;
  // border-radius: 0;
  padding: 12px 5px 12px 15px;
  color: #fff;
  height: 47px;
  caret-color: #fff;
  border-color: #3e4956;
}
.el-button--primary {
  background-color: @teal;
  border-color: @teal;

  &:hover,
  &.active,
  &:focus {
    background: lighten(@teal, 7);
    border-color: lighten(@teal, 7);
  }
}
.login .el-input__inner:hover {
  border-color: #3e4956;
}
.login .el-input__prefix {
  background: @inputbg;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;
  .el-input__icon {
    width: 30px;
  }
}
.login .el-input input {
  padding-left: 35px;
}
.login .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}
h2 {
  font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
  padding-bottom: 10px;
  text-align: center;
  font-size: 18px;
  color: #454a4e;
}
a {
  color: @teal;
  text-decoration: none;
  &:hover,
  &:active,
  &:focus {
    color: lighten(@teal, 7);
  }
}
.login .el-card {
  //   width: 340px;
  width: 450px;
  display: flex;
  justify-content: center;
}
.closeStyle{
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}
.ukStyle{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/modularMainLogin.vue